import { Accordion, AccordionDetails, AccordionSummary, Box, Stack, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import ConfirmationNumberOutlinedIcon from '@mui/icons-material/ConfirmationNumberOutlined';
import ManageAccountsIcon from '@mui/icons-material/ManageAccounts';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { getResumenContabilidadUsuario } from '../services/apis';

const formatoEuro = (valor) => {
    const numero = parseFloat(valor);
    return (isNaN(numero) ? 0 : numero).toLocaleString('ca-ES', { style: 'currency', currency: 'EUR' });
};

const ImportesEstado = ({ pendiente, confirmado }) => (
    <Stack className="side-money-statuses">
        <Typography className="side-money-pending">Pendent: {formatoEuro(pendiente)}</Typography>
        <Typography className="side-money-confirmed">Confirmat: {formatoEuro(confirmado)}</Typography>
    </Stack>
);

const ResumenConceptos = ({ conceptos, emptyText }) => (
    <Stack className="side-concept-list">
        {conceptos?.length ? conceptos.map((concepto) => (
            <Box key={concepto.concepto} className="side-concept-row">
                <Typography>{concepto.concepto}</Typography>
                <ImportesEstado pendiente={concepto.pendiente} confirmado={concepto.confirmado} />
            </Box>
        )) : <Typography className="side-empty-text">{emptyText}</Typography>}
    </Stack>
);

export const SideUserAccounting = ({ year = new Date().getFullYear(), onYearsChange }) => {
    const [loaded, setLoaded] = useState(false);
    const [resumen, setResumen] = useState(null);

    useEffect(() => {
        const cargarResumen = async () => {
            setLoaded(false);
            try {
                const response = await getResumenContabilidadUsuario(year);
                if (response?.success) {
                    setResumen(response.data);
                    onYearsChange?.(response.data?.years || []);
                }
            } catch (error) {
                console.error('Error en carregar el resum economic lateral:', error);
            } finally {
                setLoaded(true);
            }
        };

        cargarResumen();
    }, [year, onYearsChange]);

    if (!loaded || !resumen) return null;

    return (
        <Box className="side-info-card">
            <Box className="side-info-heading">
                <AccountBalanceWalletIcon fontSize="small" />
                <Typography className="side-widget-title">El teu any {year}</Typography>
            </Box>

            <Stack className="side-money-list">
                <Accordion elevation={0} className="side-money-accordion side-money-income">
                    <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />}>
                        <TrendingUpIcon fontSize="small" />
                        <Typography>Aportacions</Typography>
                        <ImportesEstado pendiente={resumen.ingresos_pendientes} confirmado={resumen.ingresos_confirmados} />
                    </AccordionSummary>
                    <AccordionDetails>
                        <ResumenConceptos conceptos={resumen.ingresos_por_concepto} emptyText="No tens aportacions aquest any." />
                    </AccordionDetails>
                </Accordion>
                <Accordion elevation={0} className="side-money-accordion side-money-expense">
                    <AccordionSummary expandIcon={<ExpandMoreIcon fontSize="small" />}>
                        <ManageAccountsIcon fontSize="small" />
                        <Typography>Despeses</Typography>
                        <ImportesEstado pendiente={resumen.gastos_pendientes} confirmado={resumen.gastos_confirmados} />
                    </AccordionSummary>
                    <AccordionDetails>
                        <ResumenConceptos conceptos={resumen.gastos_por_concepto} emptyText="No tens despeses aquest any." />
                    </AccordionDetails>
                </Accordion>
                <Box className="side-money-row side-money-ticket">
                    <ConfirmationNumberOutlinedIcon fontSize="small" />
                    <Typography>Tiquets</Typography>
                    <ImportesEstado pendiente={resumen.tickets_pendientes} confirmado={resumen.tickets_confirmados} />
                </Box>
            </Stack>
        </Box>
    );
};
